import { Box, Tooltip, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import RepeatIcon from '@mui/icons-material/Repeat';

export interface SeriesBadgeProps {
    label: string;
    recurrence?: string | null;
    active?: boolean;
    onClick?: () => void;
}

const SERIES_COLOR = '#6B4FA3';

export function SeriesBadge({
    label,
    recurrence,
    active = false,
    onClick,
}: SeriesBadgeProps) {
    const theme = useTheme();
    const clickable = Boolean(onClick);

    return (
        <Tooltip
            title={
                recurrence
                    ? `Series · repeats ${recurrence}. Click to filter.`
                    : 'Series. Click to filter.'
            }
            placement="top"
            disableInteractive
        >
            <Box
                onClick={event => {
                    if (!clickable) return;
                    event.stopPropagation();
                    onClick?.();
                }}
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '3px',
                    pl: '3px',
                    pr: 0.5,
                    mr: 0.25,
                    borderRadius: '3px',
                    border: '1px solid',
                    borderColor: alpha(SERIES_COLOR, active ? 0.9 : 0.45),
                    bgcolor: alpha(SERIES_COLOR, active ? 0.2 : 0.07),
                    flexShrink: 0,
                    cursor: clickable ? 'pointer' : 'default',
                    '&:hover': clickable
                        ? { borderColor: alpha(SERIES_COLOR, 0.9) }
                        : undefined,
                }}
            >
                <RepeatIcon
                    sx={{
                        fontSize: 11,
                        color: alpha(
                            theme.palette.mode === 'dark' ? '#C3AEE8' : SERIES_COLOR,
                            active ? 1 : 0.85,
                        ),
                    }}
                />
                <Typography
                    sx={{
                        fontSize: '9px',
                        fontWeight: 700,
                        letterSpacing: '0.02em',
                        color:
                            theme.palette.mode === 'dark' ? '#C3AEE8' : SERIES_COLOR,
                        whiteSpace: 'nowrap',
                        lineHeight: 1.6,
                    }}
                >
                    {label}
                </Typography>
            </Box>
        </Tooltip>
    );
}